import { i18n } from '../../../../../../../shared/helpers/i18n';
import { FONT_FAMILY, TEXT_COLOR_PRIMARY, TEXT_COLOR_SECONDARY } from '../constants';
import { Area, Coordinates, Drawer } from '../types';
import { SCALE } from './constants';

const TITLE_FONT_SIZE = Math.round(28 * SCALE);
const TITLE_FONT = `${TITLE_FONT_SIZE}px ${FONT_FAMILY}`;
const TITLE_HEIGHT = Math.round(32 * SCALE);
const TITLE_MARGIN_BOTTOM = Math.round(12 * SCALE);
const SUBTITLE_FONT_SIZE = Math.round(18 * SCALE);
const SUBTITLE_FONT = `${SUBTITLE_FONT_SIZE}px ${FONT_FAMILY}`;
const SUBTITLE_HEIGHT = Math.round(22 * SCALE);
export const HEADER_HEIGHT = TITLE_HEIGHT + TITLE_MARGIN_BOTTOM + SUBTITLE_HEIGHT;

export class HeaderDrawer implements Drawer {
    private area: Area;
    private titleCoordinates?: Coordinates;
    private subtitleCoordinates?: Coordinates;
    private titleMessage?: string;
    private subtitleMessage?: string;

    constructor(area: Area) {
        this.area = area;
    }

    private drawTitle(ctx: CanvasRenderingContext2D) {
        const message = this.titleMessage || i18n('dtmf', 'command-list.title');

        if (!message) {
            return;
        }

        ctx.textBaseline = 'top';
        ctx.font = TITLE_FONT;
        ctx.fillStyle = TEXT_COLOR_PRIMARY;

        if (!this.titleCoordinates) {
            const textMetrics = ctx.measureText(message);
            const x = Math.round(this.area.x + (this.area.width - textMetrics.width) / 2);
            const y = this.area.y;

            this.titleCoordinates = { x, y };
        }

        ctx.fillText(message, this.titleCoordinates.x, this.titleCoordinates.y);
    }

    private drawSubtitle(ctx: CanvasRenderingContext2D) {
        const message = this.subtitleMessage || i18n('dtmf', 'command-list.subtitle');

        if (!message) {
            return;
        }

        ctx.textBaseline = 'top';
        ctx.font = SUBTITLE_FONT;
        ctx.fillStyle = TEXT_COLOR_SECONDARY;

        if (!this.subtitleCoordinates) {
            const textMetrics = ctx.measureText(message);
            const x = Math.round(this.area.x + (this.area.width - textMetrics.width) / 2);
            const y = this.area.y + TITLE_HEIGHT + TITLE_MARGIN_BOTTOM;

            this.subtitleCoordinates = { x, y };
        }

        ctx.fillText(message, this.subtitleCoordinates.x, this.subtitleCoordinates.y);
    }

    draw(ctx: CanvasRenderingContext2D) {
        this.drawTitle(ctx);
        this.drawSubtitle(ctx);
    }
}
